import { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

import '../Roles/roles.css';
import '../Team/team.css';
import './system.css';
import { BackupsTab } from './BackupsTab';
import { MigrationsTab } from './MigrationsTab';

type SystemTab = 'migrations' | 'backups';

/** Platform-owner tools: data migrations and database backups. */
export const SystemV2 = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<SystemTab>('migrations');
  return (
    <div className="team-page">
      <Tabs
        value={tab}
        onChange={(_, v: SystemTab) => setTab(v)}
        sx={{
          minHeight: 44,
          '& .MuiTab-root': { fontSize: 13, minHeight: 44, textTransform: 'none', fontWeight: 500 },
          '& .Mui-selected': { color: '#059669' },
          '& .MuiTabs-indicator': { background: '#059669' },
        }}
      >
        <Tab value="migrations" label={t('dashboard.system.tabs.migrations')} />
        <Tab value="backups" label={t('dashboard.system.tabs.backups')} />
      </Tabs>
      {tab === 'migrations' ? <MigrationsTab /> : <BackupsTab />}
    </div>
  );
};

export default SystemV2;
